import React from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { Skeleton } from "antd";
import { EmergencyContacts } from "./Partials/EmergencyContacts";
import { FamilyInformation } from "./Partials/FamilyInformation";
import { PlaceOfWorship } from "./Partials/PlaceOfWorship";
import PersonalInfoModal from "../../../components/modelpopup/Profile/PersonalInfoModal";
import { EducationInformation } from "./Partials/EducationInformation";
import { WorkExperience } from "./Partials/WorkExperience";
import Documents from "./Partials/Documents";
import AttendanceReportTab from "./Partials/AttendanceReportTab";
import PayslipTab from "./Partials/PayslipTab";
import NotesTab from "./Partials/NotesTab";

const ProfileTab = ({details, user}) => {


  return (
    <>
      <div className="tab-content">
        <div
          id="emp_profile"
          className="pro-overview tab-pane fade show active"
        >
          <div className="row">
            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Personal Informations{" "}
                    <Link
                      to="#"
                      className="edit-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#personal_info_modal"
                    >
                      <i className="fa fa-pencil" />
                    </Link>
                  </h3>
                  {!details ?
                    <Skeleton paragraph={{rows: 6}}/>
                    :
                    <ul className="personal-info">
                      <li>
                        <div className="title">Phone:</div>
                        <div className="text"><a href="">{details?.phone}</a></div>
                      </li>
                      <li>
                        <div className="title">Email:</div>
                        <div className="text"><a href="">{details?.email}</a></div>
                      </li>
                      <li>
                        <div className="title">Birthday:</div>
                        <div className="text">{dayjs(details?.date_of_birth).format('DD MMMM')}</div>
                      </li>
                      <li>
                        <div className="title">Address:</div>
                        <div className="text">{details?.address || 'N/A'}</div>
                      </li>
                      <li>
                        <div className="title">Gender:</div>
                        <div className="text">{details?.gender}</div>
                      </li>
                      <li>
                        <div className="title">Place of Birth.</div>
                        <div className="text">{details?.place_of_birth || 'Na'}</div>
                      </li>
                      <li>
                        <div className="title">State of Origin</div>
                        <div className="text">{details?.state_of_origin || "N/A"}</div>
                      </li>
                      <li>
                        <div className="title">Nationality</div>
                        <div className="text">{details?.nationality}</div>
                      </li>
                      <li>
                        <div className="title">Religion</div>
                        <div className="text">{details?.religion || 'N/A'}</div>
                      </li>
                      <li>
                        <div className="title">Marital status</div>
                        <div className="text">{details?.marital_status || 'N/A'}</div>
                      </li>
                    </ul>}
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex">
              <EmergencyContacts details={details} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 d-flex">
              <FamilyInformation details={details} />
            </div>
            <div className="col-md-6 d-flex">
              <PlaceOfWorship details={details} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 d-flex">
              <EducationInformation details={details} />
            </div>

            <div className="col-md-6 d-flex">
              <WorkExperience details={details} />
            </div>
          </div>
        </div>

        {/* Documents Tab */}
        <div className="tab-pane fade" id="emp_projects">
          {details?.id && <Documents emp_id={details.id} />}
        </div>

        {/* Attendance Report Tab */}
        <AttendanceReportTab employeeId={details?.id} />

        {/* Payslip Tab */}
        <PayslipTab employeeId={details?.id} />

        {/* Notes Tab */}
        <NotesTab employeeId={details?.id} />
      </div>
      {/* Model Popup*/}
      {/* <PersonalInformationModelPopup /> */}
      <PersonalInfoModal data={details} user={user} />
    </>
  );
};

export default ProfileTab;
